import React from 'react';

export default function InactivePromotionContact({ contact }: { contact?: string | null }) {
  const details = contact?.trim();
  if (!details) return null;

  return <section className="promotion-card promotion-inactive-contact" aria-labelledby="inactive-contact-title">
    <h2 id="inactive-contact-title" className="promotion-section-title">연락처</h2>
    <p className="promotion-contact">{details.split(/(https?:\/\/[^\s<>"']+)/g).map((part, index) => {
      if (!/^https?:\/\//i.test(part)) return part;
      try {
        const url = new URL(part);
        if (!['http:', 'https:'].includes(url.protocol)) return part;
        return <a key={index} href={url.href} target="_blank" rel="noopener noreferrer">{part}</a>;
      } catch {
        return part;
      }
    })}</p>
  </section>;
}
